<template>
  <div id="Question">
    <div v-for="(q, index) in fragen[uebung]" :key="q" class="question">
      <div class="questionText">{{ q }}</div>
      <div class="QuestionSelectHolder">
        <div
          v-for="i in 10"
          :key="i"
          class="questionAnswer notranslate pointer"
          :class="[
            answers[index] == i || feedback[index] == i ? 'selected' : '',
          ]"
          @click="selectAnswer(index, i)"
        >
          {{ i }}
        </div>
      </div>
    </div>
    <div id="score">
      {{ scoreFilter(score) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",
  components: {},
  props: {
    fragen: {
      type: Object,
      default: () => {},
    },
    uebung: {
      type: String,
      default: () => "A",
    },
    reviewMode: {
      type: Boolean,
      default: () => false,
    },
    nutzer: {
      type: String,
      default: () => "",
    },
    me: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      answers: new Array(3).fill(0),
      score: 0,
      feedback: [],
    };
  },

  methods: {
    reset() {
      console.log("RESET QUESTIONS");
      this.score = 0;
      this.answers = new Array(3).fill(0);
    },
    calcScore() {
      let sum = 0;
      let count = this.answers.length;
      for (const a of this.answers) {
        sum += a;
      }
      this.score = Math.round((sum / count) * 10 * 10) / 10;
    },
    selectAnswer(which, i) {
      if (this.reviewMode) return;
      if (this.answers[which] == i) {
        this.answers[which] = 0;
      } else {
        this.answers[which] = i;
      }
      this.calcScore();
      this.$emit("answer", this.answers);
    },
    numberFilter(n) {
      return parseFloat(n).toLocaleString("de-DE");
    },
    scoreFilter() {
      if (this.score == 0) return "--,-";
      let s = this.numberFilter(this.score);
      if (!String(s).includes(",")) {
        return s + ",0";
      }
      return s;
    },
  },
  created() {
    console.log("created");
    try {
      this.feedback = this.me[this.uebung][this.nutzer].data;
    } catch (e) {
      this.feedback = [];
    }
    if (this.reviewMode) {
      this.answers = this.feedback;
      this.calcScore();
    }
    // console.log(this.fragen);
  },
};
</script>

<style scoped>
#score {
  text-align: center;
  font-size: 3em;
  -webkit-text-stroke-color: var(--green);
  color: white;
  -webkit-text-stroke-width: 2px;
}

.questionText {
  text-align: center;
  margin-bottom: 20px;
  margin-left: -5px;
  margin-right: -5px;
}

.QuestionSelectHolder {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: space-around;
  /* background: linear-gradient(to right, #00ffd7 0%, #14ff00 100%); */
  /* background: linear-gradient(to right, #49ab5b 0%, #2b6536 100%); */
  /* background: linear-gradient(to right, #2b6536 0%, #49ab5b 100%); */
  background: linear-gradient(to right, #8b1d44 0%, #c10b4b 100%);
}
.questionAnswer {
  width: min(7vw, 45px);
  height: min(7vw, 45px);
  background: white;
  text-align: center;
  line-height: min(7.6vw, 49px);
  font-size: min(5.3vw, 32px);
  border-radius: 2px;
  border: 1px solid var(--darkgreen);
  color: var(--darkgreen);
  box-shadow: 0px 0px 0px min(calc((10vw - min(7vw, 45px)) / 2 - 1px), 13px)
    white;
}

.question {
  margin-bottom: 4vh;
  font-size: 18px;
}

.selected {
  background: transparent !important;
  border: 1px solid transparent !important;
  color: white;
}

@media screen and (min-width: 500px) {
  .questionText {
    margin-bottom: 10px;
  }

  .question {
    margin-bottom: 35px;
  }
}

@media screen and (max-height: 750px) {
  .questionText {
    margin-bottom: 10px;
  }

  .question {
    margin-bottom: 15px;
  }
}

@media screen and (max-height: 650px) {
  .questionText {
    margin-bottom: 10px;
  }

  .question {
    margin-bottom: 10px;
  }
}

@media screen and (max-height: 600px) {
  #Question {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 57vh;
  }
}
</style>
